import { noAuthApi } from '@/shared/api/noAuthApi';
import type { ProfileApiResponse } from '@/entities/Profile';

export type ExchangeSsoTicketResponse = ProfileApiResponse & {
  token: string;
};

interface ExchangeSsoTicketArgs {
  ticket: string;
}

const ssoApi = noAuthApi.injectEndpoints({
  endpoints: (build) => ({
    exchangeSsoTicket: build.mutation<ExchangeSsoTicketResponse, ExchangeSsoTicketArgs>({
      query: ({ ticket }) => ({
        url: '/v1/portal/sso-exchange',
        method: 'POST',
        body: { ticket },
      }),
    }),
  }),
});

export const { useExchangeSsoTicketMutation } = ssoApi;
